var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"oauth-complete"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"pink"}}),(_vm.error)?_c('p',{staticClass:"error-text mt-3"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }